import { Link } from "react-router-dom";
import { ADDRESS } from "@/lib/constants";

const SOCIAL = [["Facebook", "https://www.facebook.com/accelarymotors"], ["Instagram", "https://www.instagram.com/accelarymotors/"], ["X", "https://x.com/accelary"]];
const LEGAL = [["Privacy", "/legal/privacy"], ["Terms", "/legal/terms"], ["Booking Policy", "/legal/booking-policy"], ["Contact", "/contact"]];

export const SiteFooter = ({ compact = false }) => (
  <footer data-testid="site-footer"
    className={`flex flex-col md:flex-row gap-2 md:gap-4 items-center justify-between text-xs text-white/70 border-t border-white/10 bg-[#261F1F]/95 px-4 rounded-lg ${compact ? "py-3 md:h-12 md:py-0" : "py-5"}`}>
    <span>© {new Date().getFullYear()} Accelary Motors (Pvt) Ltd. {ADDRESS}.</span>
    <div className="flex gap-4">
      {SOCIAL.map(([l, h]) => (
        <a key={l} href={h} target="_blank" rel="noreferrer" className="hover:text-[#F86900] transition-colors" data-testid={`footer-social-${l.toLowerCase()}`}>{l}</a>
      ))}
    </div>
    <div className="flex gap-4">
      {LEGAL.map(([l, h]) => (
        <Link key={l} to={h} className="hover:text-[#F86900] transition-colors" data-testid={`footer-link-${l.toLowerCase().replace(" ", "-")}`}>{l}</Link>
      ))}
    </div>
  </footer>
);
